import { navItems } from "@/mocks/guides";

const collectionLinks = [
  { id: "collections", label: "合集内容构成" },
  { id: "adaptations", label: "潘金莲题材影视剧" },
  { id: "series", label: "潘金莲系列电影" },
  { id: "timeline", label: "潘金莲改编电影大全" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200/70">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                潘金莲电影
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              本站为围绕“潘金莲电影”的题材合集导览页，整理该题材的影视剧方向、系列电影、电视剧版本与改编脉络，
              供浏览与检索参考。所有条目均在页面内呈现，不需要跳转其他页面。
            </p>
            <span className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50 border border-secondary-200/70 text-xs text-secondary-800">
              <i className="ri-information-line"></i>
              内容为方向性整理，具体版本信息以正式发行资料为准
            </span>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              合集方向
            </h4>
            <ul className="mt-4 space-y-2.5">
              {collectionLinks.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    className="text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              页面导航
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navItems.slice(0, 5).map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    className="text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 潘金莲电影 · 题材合集导览
          </p>
          <a
            href="#top"
            className="inline-flex items-center gap-2 text-xs text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-up-line"></i>
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}